const categorySelectModal = {
    header: 'Confirmation required',
    body: 'Do You really want to perform this operation?',
    confirm: 'OK',
    cancel: 'Cancel'
};

export default categorySelectModal;